import React from 'react';

import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';
import TrashCanIcon from '../../Shared/UI/TrashCanIcon/components/TrashCanIcon';

import { useProfileState, useProfileActions } from './ProfileContext';

import educationDegreeTypeOptions from './educationDegreeTypeOptions';

import styles from './ProfileUserEducation.module.scss';

const ProfileUserEducation = ({ education }) => {
  const profileState = useProfileState();
  const { openUpdateUserEducationModal, openDeleteUserEducationModal } = useProfileActions();

  const degreeLabel = educationDegreeTypeOptions.find((option) => option.value === education.degreeType)?.displayValue;
  const yearLine = (education.graduationYear === null || education.graduationYear === undefined || education.graduationYear === '')
    ? 'In progress'
    : education.graduationYear;

  return (
    <div key={education.id} className={styles.userEducation}>
      <div className={styles.userEducationTitleContainer}>
        <p className={styles.title}>{degreeLabel}, {education.fieldOfStudy}</p>
        {profileState?.user?.isAuthenticatedUser && (
          <div className={styles.buttonContainer}>
            <Button
              variant="ghost"
              icon={<EditPencilIcon />}
              iconOnly
              aria-label="Edit Education"
              onClick={() => {
                if (profileState?.user?.isAuthenticatedUser) {
                  openUpdateUserEducationModal(education);
                }
              }}
            />
            <Button
              variant="ghost"
              icon={<TrashCanIcon />}
              iconOnly
              aria-label="Delete Education"
              onClick={() => {
                if (profileState?.user?.isAuthenticatedUser) {
                  openDeleteUserEducationModal(education);
                }
              }}
            />
          </div>
        )}
      </div>
      <p className={styles.institution}>{education.institution}</p>
      <p className={styles.graduationYear}>{yearLine}</p>
      {education.description && (
        <p className={styles.description}>{education.description}</p>
      )}
    </div>
  );
};

export default ProfileUserEducation;
